module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/an-instance.js
// module id = 346
// module chunks = 1